module.exports = __webpack_public_path__ + "img/project_btn.22e0e064.gif";